import React, { useState } from "react";

import AccessibilityButton from "./AccessibilityButton";
import AccessibilityPanel from "./AccessibilityPanel";
import Section from "./Section";
import ToggleSwitch from "./ToggleSwitch";
import Dropdown from "./Dropdown";
import Slider from "./Slider";

import { useAccessibility } from "../../accessibility";
import ResetButton from "./ResetButton";

const AccessibilityWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { settings, updateLayout, updateText, resetSettings } =
    useAccessibility();

  return (
    <>
      <AccessibilityButton onClick={() => setIsOpen(true)} />

      <AccessibilityPanel open={isOpen} onClose={() => setIsOpen(false)}>
        <Section title="Layout Options">
          <ToggleSwitch
            label="Enable High Contrast"
            checked={settings.layout.highContrast}
            onChange={(value) => updateLayout("highContrast", value)}
          />

          <ToggleSwitch
            label="Enable Black & White"
            checked={settings.layout.blackWhite}
            onChange={(value) => updateLayout("blackWhite", value)}
          />

          <ToggleSwitch
            label="Reduce Transparencies"
            checked={settings.layout.reduceTransparency}
            onChange={(value) => updateLayout("reduceTransparency", value)}
          />

          <ToggleSwitch
            label="Reduce Motion"
            checked={settings.layout.reduceMotion}
            onChange={(value) => updateLayout("reduceMotion", value)}
          />
        </Section>

        <Section title="Text Options">
          <Dropdown
            label="Font Family"
            value={settings.text.fontFamily}
            options={[
              "Default",
              "System",
              "Sans",
              "Serif",
              "Mono",
              "B612",
              "Atkinson",
              "Andika",
              
            ]}
            onChange={(value) => updateText("fontFamily", value)}
          />

          <Slider
            label="Font Size"
            min={12}
            max={28}
            value={settings.text.fontSize}
            onChange={(value) => updateText("fontSize", value)}
          />

          <Slider
            label="Letter Spacing"
            min={0}
            max={8}
            value={settings.text.letterSpacing}
            onChange={(value) => updateText("letterSpacing", value)}
          />

          <Slider
            label="Word Spacing"
            min={0}
            max={20}
            value={settings.text.wordSpacing}
            onChange={(value) => updateText("wordSpacing", value)}
          />
          <ResetButton onClick={resetSettings} />
        </Section>
      </AccessibilityPanel>
    </>
  );
};

export default AccessibilityWidget;
